import { SchemaHelperWebComponentSchema } from '../types';
import { BaseWebComponentDataProvider } from '../../../../framework/BaseWebComponentDataProvider';

export class SchemaHelperViewDataProvider extends BaseWebComponentDataProvider {
  public async getDataForView(): Promise<SchemaHelperWebComponentSchema> {
    return await this.dependencies.api.clients.LiveSearchSchema.getTables();
  }
}
